__turbopack_context__.v({
  "icon": "Header-module__vw72ta__icon",
  "inner": "Header-module__vw72ta__inner",
  "link": "Header-module__vw72ta__link",
  "linkLabel": "Header-module__vw72ta__linkLabel",
});
